/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from 'react'

import './Dialog.css'

// props
// - playlistTitle
// - gameDate
export default class Dialog extends Component {

    constructor(props) {
        super(props)
        this.lastShown = false
        this.state = { shown: false}
        this._locked = false

        this.close = this.close.bind(this)
    }

    get addClassName() {
        return ''
    }

    get title() {
        return (
            <h2>Dialog title</h2>
        )
    }

    get content() {
        return (<p>Dialog Body</p>)
    }

    get dismissUrl() {
        return false
    }

    get allowClose() {
        return true
    }

    get actionButtons() {
        return null
    }

    componentDidMount() {
        this.setState({shown: true})
    }

    componentDidUpdate(prevProps, prevState) {

    }

    willShowDialog() {

    }

    willCloseDialog() {
        // track dialog closes
    }

    didCloseDialog() {

    }

    enableLock() {
        console.log("Dialog.enableLock", document.body.className.includes("locked"))
        if (!this._locked) {
            setTimeout(() => {
                if (! document.body.className.includes("locked")) {
                    document.body.className = document.body.className += ' locked'
                }
                this._locked = true
                console.log('Dialog locked', document.body.className)
            }, 100)
        }
    }

    disableLock() {
        document.body.className = document.body.className.replace(/locked/gi, '')
        document.body.className = document.body.className.replace(/\s+/gi, '')
        this._locked = false
    }


    close(e) {
        if (e) {
            e.preventDefault()
            this.willCloseDialog()
        }
        this.setState({shown: false})
        setTimeout(() => {
            if (this.dismissUrl) {
                this.props.history.push(this.dismissUrl)
            } else {
                this.props.history.goBack()
            }
            this.setState({shown: true})
            this.didCloseDialog()
        }, 600)
    }

    render() {
        let klass = `dialog-modal ${this.addClassName}`
        if (this.state.shown) {
            klass += ' show'
        } else {
            klass += ' hide'
        }

        if (this.state.shown !== this.lastShown) {
            this.lastShown = this.state.shown
        }
        let closeHandle = this.close
        if (! this.allowClose) {
            this.closeHandle = (e) => { e.preventDefault() }
        }
        let doneButton = ''
        if (this.allowClose) {
            doneButton = (<a className="dialog-title-btn" onClick={this.close} href="#done">Done</a>)
        }

        return(
            <div className={klass}>
                <div className="dialog-shade" onClick={closeHandle} />
                <div className="dialog">
                    { this.title && (
                        <div className="dialog-title">
                            {this.title}
                            {doneButton}
                        </div>
                    )}
                    { !this.title && doneButton }
                    <div className="dialog-content">
                        {this.content}
                    </div>
                    { this.actionButtons }
                </div>
            </div>
        )
    }

}

